import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsGera } from "../../../../data/projects/Gera/data";
import { projectsGodrej } from "../../../../data/projects/Godrej/data";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";

export const EverGreenSquare = () => {
  const {
    godrejevergreensquare: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsGodrej;

  return (
    <>
      <Helmet>
        <title>Godrej Evergreen Square, Hinjewadi, Pune | Premium Homes with Green Living</title>

        <meta
          name="description"
          content="Explore Godrej Evergreen Square in Hinjewadi, Pune – a premium residential project offering sustainable living, modern amenities, and excellent connectivity. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Godrej Evergreen Square, Godrej Evergreen Square Hinjewadi, Godrej Evergreen Square Pune, Godrej Properties Hinjewadi, Godrej Hinjewadi Pune, sustainable living Pune, green homes Pune, premium residences Hinjewadi"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/godrej-evergreen-square-hinjewadi-pune"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
        <Main_Footer/>
      </div>
    </>
  );
};
